import axios from 'axios'
import Api from 'App/api'

export const logNrError = (errorInfo, titleError) => {
    return axios({
        method: 'post',
        url: Api.getUrl({ controller: 'errors', action: titleError }),
        data: {
            error_data: { ...errorInfo },
            error_message: 'testing embedded error'
        },
        headers: Api.getHeaders(),
      }).catch(() => {
        stash && stashError(error)
      })
}

